/**
 * Fetches order data for a specified order ID using a given authorization token.
 * @param {string} orderID - The ID of the order to fetch data for.
 * @param {string} token - The authorization token.
 * @returns {Promise<Object>} A promise that resolves to the response from the API.
 */
export const getOrdersID = async (orderID, token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow',
  };

  const url = `${process.env.REACT_APP_ADMIN_API_URL}/orders/dataOrderCustomer/${orderID}`;

  try {
    const resp = await fetch(url, requestOptions);
    if (!resp.ok) {
      throw new Error(`Failed to fetch order data: ${resp.statusText}`);
    }
    const response = await resp.json();
    return response;
  } catch (error) {
    console.error(error);
    throw error; // Re-throw the error so it can be handled by the calling code.
  }
};
